var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntakeFastestIconContained(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35.62,
    height: 25,
    rx: 6,
    fill: "#F3F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5158 18.9691C11.6878 19.0427 11.8877 18.9813 11.9882 18.8226L16.5585 11.5609C16.6325 11.4434 16.637 11.295 16.57 11.1737C16.5031 11.0521 16.3751 10.9766 16.2364 10.9766H13.1861L14.3205 6.4746C14.3663 6.29272 14.2737 6.10488 14.1015 6.03087C13.9304 5.95724 13.7292 6.01896 13.6291 6.1774L9.0588 13.4391C8.98478 13.5567 8.98031 13.7051 9.04727 13.8263C9.11422 13.9479 9.24217 14.0234 9.3809 14.0234H12.4311L11.2967 18.5254C11.251 18.7073 11.3436 18.8951 11.5158 18.9691Z",
    fill: "#FFBB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5158 18.9691C21.6878 19.0427 21.8877 18.9813 21.9882 18.8226L26.5585 11.5609C26.6325 11.4434 26.637 11.295 26.57 11.1737C26.5031 11.0521 26.3751 10.9766 26.2364 10.9766H23.1861L24.3205 6.4746C24.3663 6.29272 24.2737 6.10488 24.1015 6.03087C23.9304 5.95724 23.7292 6.01896 23.6291 6.1774L19.0588 13.4391C18.9848 13.5567 18.9803 13.7051 19.0473 13.8263C19.1142 13.9479 19.2422 14.0234 19.3809 14.0234H22.4311L21.2967 18.5254C21.251 18.7073 21.3436 18.8951 21.5158 18.9691Z",
    fill: "#FFBB00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntakeFastestIconContained);
export default __webpack_public_path__ + "static/media/intake-fastest-icon-contained.5b6cce06587020da46ee1258d2a9ec3b.svg";
export { ForwardRef as ReactComponent };